@use "sass:color";
@use "../../mixins/index.scss" as anchor;

:host {
  display: block;
  /** @prop --modal-width: The width of the Modal. It is set to 600 pixels. */
  --modal-width: 600px;
  /** @prop --width: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --width: var(--modal-width);

  /** @prop --modal-height: The height of the Modal. It is set to 100% of its parent container. */
  --modal-height: 100%;
  /** @prop --height: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --height: var(--modal-height);

  /** @prop --modal-border-radius: This sets the radius for the corners of the Modal */
  --modal-border-radius: var(--p-size-static-100);
  /** @prop --modal-font-family: This allows you to set a specific font-family for the Modal */
  --modal-font-family: inherit;
  /** @prop --modal-header-height: This sets the height of the header of the Modal */
  --modal-header-height: 64px;
  /** @prop --modal-padding: The padding of the content area */
  --modal-padding: var(--p-size-static-500);
  /** @prop --modal-margin-vertical: The space reserved above and below the Modal */
  --modal-margin-vertical: var(--p-size-static-1300);
  /** @prop --modal-margin-horizontal: The space reserved to the left and right of the Modal */
  --modal-margin-horizontal: var(--p-size-static-400);
}

// Set media query for variables
@media (max-width: 599px) {
  :host {
    --modal-padding: var(--p-size-static-300);
    --modal-margin-vertical: 48px;
    --modal-margin-horizontal: 0px;
  }
}

@mixin inner-modal {
}

.anchor-modal {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 20;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  font-family: var(--modal-font-family);

  &__overlay {
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    /* Fallback color */
    background-color: var(--b-color-black);
    /* Black w/ opacity. We use the sass function "transparentize" to be able use our token color with an alpha value
      And therefore we also have to use the scss variable for color.Base.Black.
    */
    background-color: color.adjust(anchor.$b-color-black, $alpha: -0.4);
  }

  &__container {
    position: relative;
    z-index: 2;
    flex-direction: column;
    box-sizing: border-box;
    width: var(--modal-width);
    max-width: calc(100% - 2 * var(--modal-margin-horizontal));
    height: var(--modal-height);
    max-height: calc(100% - 2 * var(--modal-margin-vertical));
    margin-left: var(--modal-margin-horizontal);
    margin-right: var(--modal-margin-horizontal);
    margin-top: var(--modal-margin-vertical);
    margin-bottom: var(--modal-margin-vertical);
    background-color: var(--s-color-background-default-default);
    margin-top: var(--modal-margin-vertical);
    border-radius: var(--modal-border-radius);
    background-color: var(--s-color-background-default-default);
    &:after {
      content: '';
      position: absolute;
      z-index: 1;
      top: var(--modal-header-height);
      left: 0;
      pointer-events: none;
      background-image: linear-gradient(to bottom, rgb(255, 255, 255), rgba(255, 255, 255, 0) 90%);
      width: 100%;
      height: var(--p-size-static-075);
    }
  }

  &__header {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    height: var(--modal-header-height);
    padding: 0 var(--p-size-static-100);
  }

  &__content {
    box-sizing: border-box;
    height: calc(100% - var(--modal-header-height));
    padding-right: var(--modal-padding);
    padding-bottom: var(--modal-padding);
    padding-left: var(--modal-padding);
    color: var(--s-color-text-default);
    overflow-y: auto;
  }

  &__close-btn {
    display: inline;
    padding: 0;
    margin: 0;
    border: none;
    color: var(--s-color-text-default);
    background: none;
    cursor: pointer;
    font-size: var(--p-size-dynamic-300);

    &__content {
      display: flex;
      align-items: center;
    }
  }
}

@media (max-width: 1023px) {
  .anchor-modal {
    &__container {
      margin-bottom: 0px;
      --modal-margin-vertical: 48px;
      max-height: calc(100% - var(--modal-margin-vertical));
      max-width: min(calc(100% - 2 * var(--modal-margin-horizontal)), calc(75ch - 2 * var(--modal-margin-horizontal)));
      border-bottom-left-radius: 0px;
      border-bottom-right-radius: 0px;
    }
  }
}
